module.exports = __webpack_public_path__ + "static/media/wink-emoji-svgrepo-com (1).1b326f45.svg";